module.exports = __webpack_public_path__ + "img/img_no_data2.0a99f7ef.png";